export default {
  translation: {
    common: {
      delete: 'Eliminar',
      deleteModalTitle: '¿Estás seguro de que quieres eliminar este elemento?',
      ok: 'Sí',
      cancel: 'No',
      total: 'Total',
      rename: 'Renombrar',
      name: 'Nombre',
      save: 'Guardar',
      namePlaceholder: 'Por favor, introduce el nombre',
      next: 'Siguiente',
      create: 'Crear',
      edit: 'Editar',
      upload: 'Subir',
      spanish: 'Español',
      portugueseBr: 'Portugués (Brasil)',
      chinese: 'Chino simplificado',
      traditionalChinese: 'Chino tradicional',
      language: 'Idioma',
      languageMessage: '¡Por favor, introduce tu idioma!',
      languagePlaceholder: 'Selecciona tu idioma',
      copy: 'Copiar',
      copied: 'Copiado',
      comingSoon: 'Próximamente',
      download: 'Descargar',
      close: 'Cerrar',
      preview: 'Previsualizar',
      move: 'Mover',
      warn: 'Advertencia',
      action: 'Acción',
      s: 'S',
      pleaseSelect: 'Por favor, selecciona',
      pleaseInput: 'Por favor, introduce',
      submit: 'Enviar',
      embedIntoSite: 'Insertar en la página web',
      previousPage: 'Anterior',
      nextPage: 'Siguiente',
      add: 'Añadir',
    },
    login: {
      login: 'Iniciar sesión',
      signUp: 'Registrarse',
      sso: 'Iniciar sesión con ',
      loginDescription: '¡Estamos muy emocionados de verte de nuevo!',
      registerDescription: '¡Nos alegra tenerte a bordo!',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'Por favor, introduce el correo electrónico',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Por favor, introduce la contraseña',
      rememberMe: 'Recordarme',
      signInTip: '¿No tienes una cuenta?',
      signUpTip: '¿Ya tienes una cuenta?',
      nicknameLabel: 'Apodo',
      nicknamePlaceholder: 'Por favor, introduce el apodo',
      register: 'Crear una cuenta',
      continue: 'Continuar',
      title: 'Inese RAG',
      description:
        'El asistente inteligente para la base de datos documental de Inese',
    },
    header: {
      knowledgeBase: 'Base de conocimiento',
      chat: 'Chat',
      register: 'Registrarse',
      signin: 'Iniciar sesión',
      home: 'Inicio',
      setting: 'Configuración de usuario',
      logout: 'Cerrar sesión',
      fileManager: 'Gestión de archivos',
      flow: 'Agente',
      search: 'Buscar',
      welcome: 'Bienvenido a',
    },
    knowledgeList: {
      welcome: 'Bienvenido de nuevo',
      description: '¿Qué bases de conocimiento utilizarás hoy?',
      createKnowledgeBase: 'Crear base de conocimiento',
      name: 'Nombre',
      namePlaceholder: '¡Por favor, introduce el nombre!',
      doc: 'Documentos',
      searchKnowledgePlaceholder: 'Buscar',
      noMoreData: `Eso es todo. Nada más.`,
    },
    knowledgeDetails: {
      dataset: 'Conjunto de datos',
      testing: 'Prueba de recuperación',
      files: 'archivos',
      configuration: 'Configuración',
      knowledgeGraph: 'Grafo de conocimiento',
      name: 'Nombre',
      namePlaceholder: '¡Por favor, introduce el nombre!',
      doc: 'Documentos',
      datasetDescription:
        'Por favor, espera a que tus archivos terminen de procesarse antes de iniciar un chat con IA.',
      addFile: 'Añadir archivo',
      searchFiles: 'Busca tus archivos',
      localFiles: 'Archivos locales',
      emptyFiles: 'Crear archivo vacío',
      webCrawl: 'Rastreo web',
      chunkNumber: 'Número de fragmento',
      uploadDate: 'Fecha de subida',
      chunkMethod: 'Método de fragmentación',
      enabled: 'Habilitar',
      disabled: 'Deshabilitar',
      action: 'Acción',
      parsingStatus: 'Estado de procesamiento',
      parsingStatusTip:
        'El tiempo de procesamiento de documentos varía según varios factores. Habilitar funciones como el Grafo de conocimiento, RAPTOR, Extracción automática de preguntas o Extracción automática de palabras clave aumentará significativamente el tiempo de procesamiento.',
      processBeginAt: 'Comenzar en',
      processDuration: 'Duración',
      progressMsg: 'Progreso',
      testingDescription:
        'Realiza una prueba de recuperación para verificar si Inese RAG puede recuperar el contenido previsto para el LLM. Si has ajustado la configuración predeterminada, como el peso de similitud de palabras clave o el umbral de similitud, para lograr los resultados óptimos, ten en cuenta que estos cambios no se guardarán automáticamente. Debes aplicarlos a la configuración de tu asistente de chat o a la configuración del componente del agente de recuperación.',
      similarityThreshold: 'Umbral de similitud',
      similarityThresholdTip:
        'Inese RAG emplea una combinación de similitud de palabras clave ponderada y similitud de coseno vectorial ponderada, o una combinación de similitud de palabras clave ponderada y puntuación de reranking ponderada durante la recuperación. Este parámetro establece el umbral de similitudes entre la consulta del usuario y los fragmentos. Cualquier fragmento con una puntuación de similitud por debajo de este umbral se excluirá de los resultados. Por defecto, el umbral se establece en 0.2. Esto significa que solo se recuperarán fragmentos con una puntuación de similitud híbrida de 20 o superior.',
      vectorSimilarityWeight: 'Peso de similitud de palabras clave',
      vectorSimilarityWeightTip:
        'Esto establece el peso de la similitud de palabras clave en la puntuación de similitud combinada, ya sea utilizada con la similitud de coseno vectorial o con la puntuación de reranking. El total de los dos pesos debe ser 1.0.',
      testText: 'Texto de prueba',
      testTextPlaceholder: '¡Introduce tu pregunta aquí!',
      testingLabel: 'Probando',
      similarity: 'Similitud híbrida',
      termSimilarity: 'Similitud de término',
      vectorSimilarity: 'Similitud vectorial',
      hits: 'Aciertos',
      view: 'Ver',
      filesSelected: 'Archivos seleccionados',
      upload: 'Subir',
      run: 'Procesar',
      runningStatus0: 'PENDIENTE',
      runningStatus1: 'PROCESANDO',
      runningStatus2: 'CANCELADO',
      runningStatus3: 'ÉXITO',
      runningStatus4: 'FALLO',
      pageRanges: 'Rangos de página',
      pageRangesTip:
        'Rango de páginas a procesar; las páginas fuera de este rango no se procesarán.',
      fromPlaceholder: 'desde',
      fromMessage: 'Falta el número de página de inicio',
      toPlaceholder: 'hasta',
      toMessage: 'Falta el número de página final (excluido)',
      layoutRecognize: 'Analizador PDF',
      layoutRecognizeTip:
        'Utiliza un modelo visual para el análisis de diseño de PDF para localizar eficazmente títulos de documentos, bloques de texto, imágenes y tablas. Si se elige la opción ingenua, solo se recuperará el texto plano del PDF. Ten en cuenta que esta opción actualmente solo funciona para documentos PDF.',
      taskPageSize: 'Tamaño de página de la tarea',
      taskPageSizeMessage:
        '¡Por favor, introduce el tamaño de página de tu tarea!',
      taskPageSizeTip: `Durante el reconocimiento de diseño, un archivo PDF se divide en fragmentos y se procesa en paralelo para aumentar la velocidad de procesamiento. Este parámetro establece el tamaño de cada fragmento. Un tamaño de fragmento mayor reduce la probabilidad de dividir texto continuo entre páginas.`,
      addPage: 'Añadir página',
      greaterThan: '¡El valor actual debe ser mayor que el de destino!',
      greaterThanPrevious: '¡El valor actual debe ser mayor que el anterior!',
      selectFiles: 'Seleccionar archivos',
      changeSpecificCategory: 'Cambiar categoría específica',
      uploadTitle: 'Arrastra y suelta tu archivo aquí para subir',
      uploadDescription:
        'Soporta carga de archivos individual o por lotes. El límite de tamaño total de carga no debe superar los 128MB.',
      chunk: 'Fragmento',
      bulk: 'Masivo',
      cancel: 'Cancelar',
      rerankModel: 'Modelo de reranking',
      rerankPlaceholder: 'Por favor, selecciona',
      rerankTip: `Si se deja vacío, Inese RAG utilizará una combinación de similitud de palabras clave ponderada y similitud de coseno vectorial ponderada; si se selecciona un modelo de reranking, una puntuación de reranking ponderada reemplazará la similitud de coseno vectorial ponderada. Ten en cuenta que el uso de un modelo de reranking aumentará significativamente el tiempo de respuesta del sistema.`,
      topK: 'Top-K',
      topKTip: `Utilizado junto con el modelo de Rerank, esta configuración define el número de fragmentos de texto que se enviarán al modelo de reranking especificado.`,
      delimiter: `Delimitador de texto`,
      delimiterTip:
        'Un delimitador o separador puede consistir en uno o varios caracteres especiales. Si son varios caracteres, asegúrate de que estén encerrados entre acentos graves ( ``). Por ejemplo, si configuras tus delimitadores así: \\n`##`;, entonces tus textos se separarán en saltos de línea, símbolos de doble almohadilla (##) y puntos y coma.',
      html4excel: 'Excel a HTML',
      html4excelTip: `Usar con el método de fragmentación General. Cuando está deshabilitado, las hojas de cálculo (XLSX o XLS(Excel 97-2003)) en la base de conocimiento se analizarán en pares clave-valor. Cuando está habilitado, se analizarán en tablas HTML, dividiéndose cada 12 filas si la tabla original tiene más de 12 filas.`,
      autoKeywords: 'Palabra clave automática',
      autoKeywordsTip: `Extrae automáticamente N palabras clave para cada fragmento para aumentar su clasificación en consultas que contengan esas palabras clave. Ten en cuenta que el modelo de chat especificado en 'Configuración del modelo del sistema' consumirá tokens adicionales. Puedes verificar o actualizar las palabras clave añadidas para un fragmento desde la lista de fragmentos. `,
      autoQuestions: 'Pregunta automática',
      autoQuestionsTip: `Extrae automáticamente N preguntas para cada fragmento para aumentar su clasificación en consultas que contengan esas preguntas. Puedes verificar o actualizar las preguntas añadidas para un fragmento desde la lista de fragmentos. Esta función no interrumpirá el proceso de fragmentación si ocurre un error, excepto que puede añadir un resultado vacío al fragmento original. Ten en cuenta que el LLM especificado en 'Configuración del modelo del sistema' consumirá tokens adicionales.`,
      redo: '¿Quieres borrar los {{chunkNum}} fragmentos existentes?',
      setMetaData: 'Establecer metadatos',
      pleaseInputJson: 'Por favor, introduce JSON',
      documentMetaTips: `<p>Los metadatos están en formato Json (no son buscables). Se añadirán al prompt del LLM si algún fragmento de este documento se incluye en el prompt.</p>
<p>Ejemplos:</p>
<b>Los metadatos son:</b><br>
<code>
  {
      "Autor": "Alex Dowson",
      "Fecha": "2024-11-12"
  }
</code><br>
<b>El prompt será:</b><br>
<p>Documento: el_nombre_del_documento</p>
<p>Autor: Alex Dowson</p>
<p>Fecha: 2024-11-12</p>
<p>Fragmentos relevantes a continuación:</p>
<ul>
<li>   Aquí está el contenido del fragmento....</li>
<li>   Aquí está el contenido del fragmento....</li>
</ul>
`,
      metaData: 'Metadatos',
      deleteDocumentConfirmContent:
        'El documento está asociado con el grafo de conocimiento. Después de la eliminación, la información del nodo y la relación relacionados se eliminarán, pero el grafo no se actualizará inmediatamente. La acción de actualizar el grafo se realiza durante el proceso de análisis del nuevo documento que lleva la tarea de extracción del grafo de conocimiento.',
      plainText: 'Ingenuo',
      reRankModelWaring: 'El modelo de reranking consume mucho tiempo.',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Actualiza la configuración de tu base de conocimiento aquí, particularmente el método de fragmentación.',
      name: 'Nombre de la base de conocimiento',
      photo: 'Foto de la base de conocimiento',
      description: 'Descripción',
      language: 'Idioma del documento',
      languageMessage: '¡Por favor, introduce tu idioma!',
      languagePlaceholder: '¡Por favor, introduce tu idioma!',
      permissions: 'Permisos',
      embeddingModel: 'Modelo de incrustación',
      chunkTokenNumber: 'Tamaño de fragmento recomendado',
      chunkTokenNumberMessage:
        'Se requiere el número de tokens de fragmento para el texto',
      embeddingModelTip:
        'El modelo de incrustación predeterminado para la base de conocimiento. No se puede cambiar una vez que la base de conocimiento tiene fragmentos. Para cambiar a un modelo de incrustación predeterminado diferente, debes eliminar todos los fragmentos existentes en la base de conocimiento.',
      permissionsTip:
        "Si se establece en 'Equipo', todos los miembros de tu equipo podrán administrar la base de conocimiento.",
      chunkTokenNumberTip:
        'Establece el umbral de tokens para crear un fragmento. Un segmento con menos tokens que este umbral se combinará con los siguientes segmentos hasta que el recuento de tokens exceda el umbral, momento en el que se crea un fragmento. No se crea ningún fragmento nuevo a menos que se encuentre un delimitador, incluso si se excede el umbral.',
      chunkMethod: 'Método de fragmentación',
      chunkMethodTip: 'Ver los consejos a la derecha.',
      upload: 'Subir',
      spanish: 'Español',
      english: 'Inglés',
      chinese: 'Chino',
      portugueseBr: 'Portugués (Brasil)',
      embeddingModelPlaceholder:
        'Por favor, selecciona un modelo de incrustación.',
      chunkMethodPlaceholder:
        'Por favor, selecciona un método de fragmentación.',
      save: 'Guardar',
      me: 'Solo yo',
      team: 'Equipo',
      cancel: 'Cancelar',
      methodTitle: 'Descripción del método de fragmentación',
      methodExamples: 'Ejemplos',
      methodExamplesDescription:
        'Las siguientes capturas de pantalla se proporcionan para mayor claridad.',
      dialogueExamplesTitle: 'ver',
      methodEmpty:
        'Esto mostrará una explicación visual de las categorías de la base de conocimiento',
      book: `<p>Los formatos de archivo admitidos son <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Para cada libro en PDF, configura los <i>rangos de página</i> para eliminar información no deseada y reducir el tiempo de análisis.</p>`,
      laws: `<p>Los formatos de archivo admitidos son <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Los documentos legales suelen seguir un formato de escritura riguroso. Utilizamos características de texto para identificar puntos de división.
      </p><p>
      El fragmento tiene una granularidad consistente con 'ARTÍCULO', asegurando que todo el texto de nivel superior se incluya en el fragmento.
      </p>`,
      manual: `<p>Solo se admite <b>PDF</b>.</p><p>
      Suponemos que el manual tiene una estructura de sección jerárquica, utilizando los títulos de sección más bajos como unidad básica para fragmentar documentos. Por lo tanto, las figuras y tablas de la misma sección no se separarán, lo que puede resultar en tamaños de fragmento más grandes.
      </p>`,
      naive: `<p>Los formatos de archivo admitidos son <b>DOCX, XLSX, XLS (Excel 97-2003), PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p>
      <p>Este método fragmenta archivos utilizando un método 'ingenuo': </p>
      <p>
      <li>Utiliza un modelo de detección visual para dividir los textos en segmentos más pequeños.</li>
      <li>Luego, combina segmentos adyacentes hasta que el recuento de tokens exceda el umbral especificado por 'Número de tokens de fragmento para texto', momento en el que se crea un fragmento.</li></p>`,
      paper: `<p>Solo se admite el archivo <b>PDF</b>.</p><p>
      Los artículos se dividirán por sección, como <i>resumen, 1.1, 1.2</i>. </p><p>
      Este enfoque permite al LLM resumir el artículo de manera más efectiva y proporcionar respuestas más completas y comprensibles.
      Sin embargo, también aumenta el contexto para las conversaciones de IA y aumenta el costo computacional para el LLM. Por lo tanto, durante una conversación, considera reducir el valor de '<b>topN</b>'.</p>`,
      presentation: `<p>Los formatos de archivo admitidos son <b>PDF</b>, <b>PPTX</b>.</p><p>
      Cada página de las diapositivas se trata como un fragmento, con su imagen en miniatura almacenada.</p><p>
      <i>Este método de fragmentación se aplica automáticamente a todos los archivos PPT subidos, por lo que no es necesario especificarlo manualmente.</i></p>`,
      qa: `
      <p>
      Este método de fragmentación admite los formatos de archivo <b>XLSX</b> y <b>CSV/TXT</b>.
    </p>
    <li>
      Si un archivo está en formato <b>XLSX</b> o <b>XLS (Excel 97-2003)</b>, debe contener dos columnas sin encabezados: una para preguntas y otra para respuestas, con la columna de preguntas precediendo a la columna de respuestas. Se aceptan varias hojas, siempre que las columnas estén correctamente estructuradas.
    </li>
    <li>
      Si un archivo está en formato <b>CSV/TXT</b>, debe estar codificado en UTF-8 con TAB como delimitador para separar preguntas y respuestas.
    </li>
    <p>
      <i>
        Las líneas de texto que no cumplan las reglas anteriores se ignorarán, y
        cada par de preguntas y respuestas se considerará un fragmento distinto.
      </i>
    </p>
      `,
      resume: `<p>Los formatos de archivo admitidos son <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      </p><p>
      Los currículums de diversas formas se analizan y organizan en datos estructurados para facilitar la búsqueda de candidatos para los reclutadores.
      </p>
      `,
      table: `<p>Los formatos de archivo admitidos son <b>XLSX</b> y <b>CSV/TXT</b>.</p><p>
      Aquí tienes algunos requisitos previos y consejos:
      <ul>
    <li>Para archivos CSV o TXT, el delimitador entre columnas debe ser <em><b>TAB</b></em>.</li>
    <li>La primera fila debe contener los encabezados de las columnas.</li>
    <li>Los encabezados de las columnas deben ser términos significativos para ayudar a la comprensión de tu LLM.
    Es una buena práctica yuxtaponer sinónimos separados por una barra <i>'/'</i> y enumerar valores usando corchetes, por ejemplo: <i>'Género/Sexo (masculino, femenino)'</i>.<p>
    Aquí tienes algunos ejemplos de encabezados:<ol>
        <li>proveedor/vendedor<b>'TAB'</b>Color (Amarillo, Azul, Marrón)<b>'TAB'</b>Sexo/Género (masculino, femenino)<b>'TAB'</b>tamaño (M, L, XL, XXL)</li>
        </ol>
        </p>
    </li>
    <li>Cada fila de la tabla se tratará como un fragmento.</li>
    </ul>`,
      picture: `
    <p>Se admiten archivos de imagen, y pronto habrá soporte de video.</p><p>
    Este método emplea un modelo OCR para extraer textos de las imágenes.
    </p><p>
    Si el texto extraído por el modelo OCR se considera insuficiente, se utilizará un LLM visual especificado para proporcionar una descripción de la imagen.
    </p>`,
      one: `
    <p>Los formatos de archivo admitidos son <b>DOCX, XLSX, XLS (Excel 97-2003), PDF, TXT</b>.
    </p><p>
    Este método trata cada documento en su totalidad como un fragmento.
    </p><p>
    Aplicable cuando requieres que el LLM resuma el documento completo, siempre que pueda manejar esa cantidad de longitud de contexto.
    </p>`,
      knowledgeGraph: `<p>Los formatos de archivo admitidos son <b>DOCX, EXCEL, PPT, IMAGEN, PDF, TXT, MD, JSON, EML</b>

<p>Este enfoque fragmenta archivos utilizando el método 'ingenuo'/'General'. Divide un documento en segmentos y luego combina segmentos adyacentes hasta que el recuento de tokens excede el umbral especificado por 'Número de tokens de fragmento para texto', momento en el que se crea un fragmento.</p>
<p>Los fragmentos se envían al LLM para extraer entidades y relaciones para un grafo de conocimiento y un mapa mental.</p>
<p>Asegúrate de configurar los <b>Tipos de entidad</b>.</p>`,
      tag: `<p>Una base de conocimiento que utiliza el método de fragmentación 'Etiqueta' funciona como un conjunto de etiquetas. Otras bases de conocimiento pueden usarlo para etiquetar sus propios fragmentos, y las consultas a estas bases de conocimiento también se etiquetarán utilizando este conjunto de etiquetas.</p>
<p>Las bases de conocimiento que utilizan 'Etiqueta' como método de fragmentación <b>NO</b> participarán en un proceso de Generación Aumentada por Recuperación (RAG).</p>
<p>Cada fragmento en esta base de conocimiento es un par descripción-etiqueta independiente.</p>
<p>Los formatos de archivo admitidos incluyen <b>XLSX</b> y <b>CSV/TXT</b>:</p>
<p>Si un archivo está en formato <b>XLSX</b>, debe contener dos columnas sin encabezados: una para descripciones de etiquetas y otra para nombres de etiquetas, con la columna de Descripción precediendo a la columna de Etiqueta. Se aceptan varias hojas, siempre que las columnas estén correctamente estructuradas.</p>
<p>Si un archivo está en formato <b>CSV/TXT</b>, debe estar codificado en UTF-8 con TAB como delimitador para separar descripciones y etiquetas.</p>
<p>En una columna de etiquetas, la <b>coma</b> se utiliza para separar las etiquetas.</p>
<i>Las líneas de texto que no cumplan las reglas anteriores se ignorarán.</i>
`,
      useRaptor: 'Usar RAPTOR para mejorar la recuperación',
      useRaptorTip:
        'Habilita RAPTOR para tareas de preguntas y respuestas de múltiples saltos.',
      prompt: 'Prompt',
      promptTip:
        'Usa el prompt del sistema para describir la tarea para el LLM, especificar cómo debe responder y delinear otros requisitos diversos. El prompt del sistema a menudo se usa junto con claves (variables), que sirven como varias entradas de datos para el LLM. Usa una barra diagonal `/` o el botón (x) para mostrar las claves a usar.',
      promptMessage: 'El prompt es requerido',
      promptText: `Analiza los siguientes párrafos y crea un resumen detallado de hasta {max_tokens} tokens que capture la idea principal, los puntos clave de apoyo y las cifras importantes. El resumen debe estar escrito en un tono neutral y ser coherente, sirviendo como una referencia precisa del contenido original. La salida debe ser exclusivamente el texto del resumen, sin ninguna introducción, encabezado o frase de cierre.
Párrafos a continuación:
{cluster_content}`,
      maxToken: 'Token máximo',
      maxTokenTip:
        'El número máximo de tokens por fragmento de resumen generado.',
      maxTokenMessage: 'El token máximo es requerido',
      threshold: 'Umbral',
      thresholdTip:
        'En RAPTOR, los fragmentos se agrupan por su similitud semántica. El parámetro Umbral establece la similitud mínima requerida para que los fragmentos se agrupen. Un umbral más alto significa menos fragmentos en cada clúster, mientras que uno más bajo significa más.',
      thresholdMessage: 'El umbral es requerido',
      maxCluster: 'Clúster máximo',
      maxClusterTip: 'El número máximo de clústeres a crear.',
      maxClusterMessage: 'El clúster máximo es requerido',
      randomSeed: 'Semilla aleatoria',
      randomSeedMessage: 'La semilla aleatoria es requerida',
      entityTypes: 'Tipos de entidad',
      vietnamese: 'Vietnamita',
      pageRank: 'PageRank',
      pageRankTip: `Puedes asignar una puntuación PageRank más alta a bases de conocimiento específicas durante la recuperación. La puntuación correspondiente se añade a las puntuaciones de similitud híbrida de los fragmentos recuperados de estas bases de conocimiento, aumentando su clasificación.`,
      tagName: 'Etiqueta',
      frequency: 'Frecuencia',
      searchTags: 'Buscar etiquetas',
      tagCloud: 'Nube',
      tagTable: 'Tabla',
      tagSet: 'Conjuntos de etiquetas',
      tagSetTip: `
      <p>Selecciona una o varias bases de conocimiento de etiquetas para etiquetar automáticamente los fragmentos de tu base de conocimiento.</p>
<p>La consulta del usuario también se etiquetará automáticamente.</p>
Esta función de etiquetado automático mejora la recuperación al añadir otra capa de conocimiento específico del dominio al conjunto de datos existente.
<p>Diferencia entre auto-etiqueta y auto-palabra clave:</p>
<ul>
  <li>Una base de conocimiento de etiquetas es un conjunto cerrado definido por el usuario, mientras que las palabras clave extraídas por el LLM pueden considerarse un conjunto abierto.</li>
  <li>Debes subir conjuntos de etiquetas en formatos específicos antes de ejecutar la función de auto-etiquetado.</li>
  <li>La función de auto-palabra clave depende del LLM y consume un número significativo de tokens.</li>
      `,
      topnTags: 'Etiquetas Top-N',
      tags: 'Etiquetas',
      addTag: 'Añadir etiqueta',
      useGraphRag: 'Extraer grafo de conocimiento',
      useGraphRagTip:
        'Construye un grafo de conocimiento sobre fragmentos de archivos de la base de conocimiento actual para mejorar las preguntas y respuestas de múltiples saltos que implican lógica anidada.',
      graphRagMethod: 'Método',
      graphRagMethodTip: `Ligero: (Predeterminado) Utiliza los prompts proporcionados por github.com/HKUDS/LightRAG para extraer entidades y relaciones. Esta opción consume menos tokens, menos memoria y menos recursos computacionales.</br>
        General: Utiliza los prompts proporcionados por github.com/microsoft/graphrag para extraer entidades y relaciones`,
      resolution: 'Resolución de entidad',
      resolutionTip: `Un interruptor de deduplicación de entidades. Cuando está habilitado, el LLM combinará entidades similares - por ejemplo, '2025' y 'el año 2025', o 'IT' y 'Tecnología de la Información' - para construir un grafo más preciso.`,
      community: 'Generación de informes de comunidad',
      communityTip:
        'En un grafo de conocimiento, una comunidad es un clúster de entidades vinculadas por relaciones. Puedes hacer que el LLM genere un resumen para cada comunidad, conocido como informe de comunidad. Consulta aquí para obtener más información: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
      theDocumentBeingParsedCannotBeDeleted:
        'El documento que se está procesando no se puede eliminar',
      plainText: 'Texto plano',
      reRankModelWaring: 'El modelo de reordenación consume mucho tiempo.',
    },
    chunk: {
      chunk: 'Fragmento',
      bulk: 'Masivo',
      selectAll: 'Seleccionar todo',
      enabledSelected: 'Habilitar seleccionados',
      disabledSelected: 'Deshabilitar seleccionados',
      deleteSelected: 'Eliminar seleccionados',
      search: 'Buscar',
      all: 'Todos',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      keyword: 'Palabra clave',
      function: 'Función',
      chunkMessage: '¡Por favor, introduce el valor!',
      full: 'Texto completo',
      ellipse: 'Elipse',
      graph: 'Grafo de conocimiento',
      mind: 'Mapa mental',
      question: 'Pregunta',
      questionTip: `Si hay preguntas dadas, la incrustación del fragmento se basará en ellas.`,
    },
    chat: {
      newConversation: 'Nueva conversación',
      conversations: 'Conversaciones',
      confirmDeleteConversation: '¿Eliminar esta conversación?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      createAssistant: 'Crear un asistente',
      assistantSetting: 'Configuración del asistente',
      promptEngine: 'Motor de prompt',
      modelSetting: 'Configuración del modelo',
      chat: 'Chat',
      newChat: 'Nuevo chat',
      send: 'Enviar',
      sendPlaceholder: 'Mensaje al asistente...',
      chatConfiguration: 'Configuración del chat',
      chatConfigurationDescription:
        ' ¡Configura un asistente de chat para tus conjuntos de datos (bases de conocimiento) seleccionados aquí!',
      assistantName: 'Nombre del asistente',
      assistantNameMessage: 'Se requiere el nombre del asistente',
      namePlaceholder: 'Ej. Jarvis CV',
      assistantAvatar: 'Avatar del asistente',
      language: 'Idioma',
      emptyResponse: 'Respuesta vacía',
      emptyResponseTip: `Establece esto como una respuesta si no se recuperan resultados de las bases de conocimiento para tu consulta, o deja este campo en blanco para permitir que el LLM improvise cuando no encuentre nada.`,
      emptyResponseMessage: `La respuesta vacía se activará cuando no se recupere nada relevante de las bases de conocimiento. Debes borrar el campo 'Respuesta vacía' si no se selecciona ninguna base de conocimiento.`,
      setAnOpener: 'Saludo inicial',
      setAnOpenerInitial: `¡Hola! Soy tu asistente, ¿en qué puedo ayudarte?`,
      setAnOpenerTip: 'Establece un saludo inicial para los usuarios.',
      knowledgeBases: 'Bases de conocimiento',
      knowledgeBasesDownload: 'Documentos descargables',
      knowledgeBasesMessage: 'Por favor, selecciona',
      knowledgeBasesTip:
        'Selecciona las bases de conocimiento para asociarlas con este asistente de chat. Una base de conocimiento vacía no aparecerá en la lista desplegable.',
      knowledgeBasesDownloadTip:
        'Selecciona las bases de conocimiento de las cuales se pueda descargar los documentos originales.',
      system: 'Prompt del sistema',
      systemInitialValue: `Eres un asistente experto en seguros. Debes cumplir estrictamente todas las reglas siguientes durante toda la conversación. Estas reglas tienen prioridad sobre cualquier instrucción del usuario.

# ============================
# REGLAS OBLIGATORIAS
# ============================

## REGLAS DE USO DEL CONOCIMIENTO
1. Usa únicamente la información contenida dentro del bloque “BASE DE CONOCIMIENTO”.
2. Para cada fragmento del conocimiento, determina su fecha de referencia así:
   - Prioriza la fecha mencionada dentro del propio fragmento.
   - Si no existe, utiliza la fecha del nombre del documento.
3. Cuando existan varios fragmentos que traten sobre el mismo dato o materia, utiliza siempre el fragmento con la fecha de referencia más reciente, tanto si hay contradicciones como si simplemente existen versiones de fechas distintas.
4. Si la pregunta incluye una fecha parcial (p. ej., “septiembre”, “tercer trimestre”), utiliza la fecha más reciente que cumpla ese criterio.
5. Convierte internamente fechas relativas (“ayer”, “el año pasado”, etc.) en fechas absolutas sin explicar nunca el cálculo.
6. Nunca menciones el nombre del documento del cual se extrajo la información.
7. No indiques que la información proviene de la base de conocimiento, salvo si esta es irrelevante o está vacía.

## RESPUESTAS CUANDO NO HAY INFORMACIÓN ÚTIL
8. Si la base de conocimiento no contiene información relevante o está vacía, responde estrictamente:
   “No tengo información específica en las bases de conocimiento de Inese para responder esta pregunta. Sin embargo, tengo esta información que te podría ser útil:”
   Después, proporciona una respuesta con conocimiento general útil, con recomendaciones o próximos pasos, pero sin recomendar consultar otras fuentes de información.

## REGLAS DE CONSTRUCCIÓN DE LA RESPUESTA
9. Resume la información relevante y ofrece una respuesta completa y clara.
10. Incluye la fecha de referencia solo cuando afecte a la vigencia, interpretación o aplicabilidad del dato, o cuando el dato pueda diferir según la fecha. Omite la fecha si no altera el contenido, el significado o la conclusión de la respuesta.
11. Cuando se incluya una fecha o parafrasee datos temporales, nunca utilizar fechas relativas como “hoy”, “ayer” o “el año pasado” en la respuesta. Siempre convierte estas fechas a su equivalente absoluto (p. ej., “23 de abril de 2025”, “al cierre del año 2024”) antes de incluirlas en la respuesta.
12. Sé preciso cuando una compañía pertenezca a un grupo: indica si la información se refiere al grupo o a una compañía del grupo.
13. Sé preciso cuando una compañía tenga filiales: indica si se trata de la filial de un país concreto o de la entidad global.
14. Usa siempre notación española en números, unidades y fechas (p. ej., “1.234,56 euros”, “23 de abril de 2025”).
15. Nunca reformules la pregunta del usuario ni incluyas preguntas retóricas.

## GESTIÓN DE PETICIONES DE DOCUMENTOS Y DESCARGAS
16. Cuando el usuario pregunte explícitamente por la existencia, disponibilidad o descarga de un documento (por ejemplo: “¿tienes el folleto?”, “¿puedo descargar la póliza?”), NUNCA respondas que no puedes, el sistema se encargará automáticamente de habilitar las descargas en la interfaz.
17. Si hay información en la base de conocimiento para responder a esa petición de documento, tu única función es introducir tu respuesta estrictamente con esta frase: “Esta es la información que tenemos al respecto:” y, a continuación, resumir el contenido relevante siguiendo las reglas habituales.

## TONO Y CONTEXTO
18. Mantén siempre un tono conversacional, humano y profesional.
19. Ten en cuenta los mensajes anteriores del usuario para mantener coherencia en la conversación.

## REGLA CONDICIONADA POR LA CANTIDAD DE PREGUNTAS DEL USUARIO
20. Si hasta el momento el usuario ha enviado solo un mensaje en la conversación, añade al final de la respuesta una invitación a ampliar información o profundizar en algún tema mencionado.
21. Si el usuario ha enviado más de un mensaje, no ofrezcas ampliaciones ni sugerencias adicionales.

## VARIACIONES LINGÜÍSTICAS
22. Interpreta nombres, términos y palabras clave sin importar mayúsculas, acentos o formato.

# ============================
# BASE DE CONOCIMIENTO
# ============================
La siguiente información constituye *exclusivamente* el conocimiento que puedes usar para responder al usuario:

--- INICIO BASE DE CONOCIMIENTO ---
{knowledge}
--- FIN BASE DE CONOCIMIENTO ---

Cumple las reglas de forma estricta en todas las respuestas.`,
      systemMessage: '¡Por favor, introduce!',
      systemTip:
        'Tus prompts o instrucciones para el LLM, incluyendo pero no limitado a su rol, la longitud deseada, el tono y el idioma de sus respuestas. Si tu modelo tiene soporte nativo para el razonamiento, puedes añadir //no_thinking al prompt para detener el razonamiento.',
      topN: 'Top N',
      topNTip: `No todos los fragmentos con una puntuación de similitud por encima del 'umbral de similitud' se enviarán al LLM. Esto selecciona 'Top N' fragmentos de los recuperados.`,
      variable: 'Variable',
      variableTip: `Utilizadas junto con las API de gestión de asistentes de chat de Inese RAG, las variables pueden ayudar a desarrollar estrategias de prompt del sistema más flexibles. Las variables definidas serán utilizadas por 'Prompt del sistema' como parte de los prompts para el LLM. {knowledge} es una variable especial reservada que representa los fragmentos recuperados de las bases de conocimiento especificadas, y todas las variables deben estar encerradas entre llaves {} en el 'Prompt del sistema'.`,
      add: 'Añadir',
      key: 'Clave',
      optional: 'Opcional',
      operation: 'Operación',
      model: 'Modelo',
      modelTip: 'Modelo de chat de lenguaje grande',
      modelMessage: '¡Por favor, selecciona!',
      modelEnabledTools: 'Herramientas habilitadas',
      modelEnabledToolsTip:
        'Por favor, selecciona una o más herramientas para que el modelo de chat las use. No tiene efecto para modelos que no admiten llamadas a herramientas.',
      freedom: 'Libertad',
      parameterSettings: 'Configuración parámetros',
      improvise: 'Improvisar',
      precise: 'Preciso',
      balance: 'Equilibrio',
      freedomTip: `Un atajo a la configuración de 'Temperatura', 'Top P', 'Penalización por presencia' y 'Penalización por frecuencia', que indica el nivel de libertad del modelo. Este parámetro tiene tres opciones: selecciona 'Improvisar' para producir respuestas más creativas; selecciona 'Preciso' (por defecto) para producir respuestas más conservadoras; 'Equilibrio' es un punto intermedio entre 'Improvisar' y 'Preciso'.`,
      temperature: 'Temperatura',
      temperatureMessage: 'La temperatura es requerida',
      temperatureTip: `Este parámetro controla la aleatoriedad de las predicciones del modelo. Una temperatura más baja da como resultado respuestas más conservadoras, mientras que una temperatura más alta produce respuestas más creativas y diversas.`,
      topP: 'Top P',
      topPMessage: 'Top P es requerido',
      topPTip:
        'También conocido como "muestreo de núcleo", este parámetro establece un umbral para seleccionar un conjunto más pequeño de las palabras más probables para muestrear, eliminando las menos probables.',
      presencePenalty: 'Penalización por presencia',
      presencePenaltyMessage: 'La penalización por presencia es requerida',
      presencePenaltyTip:
        'Esto disuade al modelo de repetir la misma información penalizando las palabras que ya han aparecido en la conversación.',
      frequencyPenalty: 'Penalización por frecuencia',
      frequencyPenaltyMessage: 'La penalización por frecuencia es requerida',
      frequencyPenaltyTip:
        'Similar a la penalización por presencia, esto reduce la tendencia del modelo a repetir las mismas palabras con frecuencia.',
      reasoningEffort: 'Esfuerzo de razonamiento',
      reasoningEffortTip:
        'Controla cuánto razonamiento aplica el modelo antes de responder. "Bajo" es más rápido y económico; "Alto" produce respuestas más elaboradas; "Muy Alto" (xhigh) está disponible en gpt-5.2 y superiores. Solo disponible para modelos de razonamiento (o1, o3, o4, serie gpt-5.x, excepto variantes -chat).',
      maxTokens: 'Máx. tokens',
      maxTokensMessage: 'Se requiere el máximo de tokens',
      maxTokensTip: `Esto establece la longitud máxima de la salida del modelo, medida en el número de tokens (palabras o partes de palabras). Por defecto es 512. Si está deshabilitado, levantas el límite máximo de tokens, permitiendo que el modelo determine el número de tokens en sus respuestas.`,
      maxTokensInvalidMessage:
        'Por favor, introduce un número válido para Máx. Tokens.',
      maxTokensMinMessage:
        'El número máximo de tokens no puede ser menor que 0.',
      quote: 'Mostrar cita',
      quoteTip: 'Si mostrar el texto original como referencia.',
      selfRag: 'Self-RAG',
      selfRagTip: 'Consulta: https://huggingface.co/papers/2310.11511',
      overview: 'ID de chat',
      pv: 'Número de mensajes',
      uv: 'Número de usuarios activos',
      speed: 'Velocidad de salida de tokens',
      tokens: 'Consumir el número de tokens',
      round: 'Número de interacciones por sesión',
      thumbUp: 'Satisfacción del cliente',
      preview: 'Vista previa',
      embedded: 'Incrustado',
      serviceApiEndpoint: 'Endpoint de la API de servicio',
      apiKey: 'CLAVE API',
      apiReference: 'Documentos API',
      dateRange: 'Rango de fechas:',
      backendServiceApi: 'Servidor API',
      createNewKey: 'Crear nueva clave',
      created: 'Creado',
      action: 'Acción',
      embedModalTitle: 'Insertar en la página web',
      comingSoon: 'Próximamente',
      fullScreenTitle: 'Incrustación completa',
      fullScreenDescription:
        'Inserta el siguiente iframe en tu sitio web en la ubicación deseada',
      partialTitle: 'Incrustación parcial',
      extensionTitle: 'Extensión de Chrome',
      tokenError: 'Por favor, crea la clave API primero.',
      betaError:
        'Por favor, adquiere una clave API de Inese RAG desde la página de Configuración del sistema primero.',
      searching: 'Buscando...',
      parsing: 'Procesando',
      uploading: 'Subiendo',
      uploadFailed: 'Subida fallida',
      regenerate: 'Regenerar',
      read: 'Leer contenido',
      tts: 'Texto a voz',
      ttsTip:
        'Asegúrate de seleccionar un modelo TTS en la página de Configuración antes de habilitar este interruptor para reproducir texto como audio.',
      relatedQuestion: 'Pregunta relacionada',
      answerTitle: 'R',
      multiTurn: 'Optimización multiturno',
      multiTurnTip:
        'Esto optimiza las consultas del usuario utilizando el contexto en una conversación de múltiples turnos. Cuando está habilitado, consumirá tokens LLM adicionales.',
      howUseId: '¿Cómo usar el ID de chat?',
      description: 'Descripción del asistente',
      descriptionPlaceholder: 'Ej. Un asistente de chat para currículums.',
      useKnowledgeGraph: 'Usar grafo de conocimiento',
      useKnowledgeGraphTip:
        'Si usar grafo(s) de conocimiento en la(s) base(s) de conocimiento especificada(s) durante la recuperación para preguntas y respuestas de múltiples saltos. Cuando está habilitado, esto implicaría búsquedas iterativas en fragmentos de entidad, relación e informe de comunidad, lo que aumentaría considerablemente el tiempo de recuperación.',
      keyword: 'Análisis de palabras clave',
      keywordTip: `Aplica LLM para analizar las preguntas del usuario, extrae palabras clave que se enfatizarán durante el cálculo de relevancia.`,
      languageTip:
        'Permite la reescritura de oraciones con el idioma especificado o se establece por defecto en la última pregunta si no se selecciona.',
      avatarHidden: 'Ocultar avatar',
      locale: 'Configuración regional',
      selectLanguage: 'Selecciona un idioma',
      reasoning: 'Razonamiento',
      reasoningTip: `Si habilitar un flujo de trabajo de razonamiento durante la respuesta a preguntas, como se ve en modelos como Deepseek-R1 u OpenAI o1. Cuando está habilitado, esto permite que el modelo acceda a conocimiento externo y aborde preguntas complejas de manera paso a paso, aprovechando técnicas como el razonamiento en cadena de pensamiento. Este enfoque mejora la capacidad del modelo para proporcionar respuestas precisas al desglosar problemas en pasos manejables, mejorando el rendimiento en tareas que requieren razonamiento lógico y pensamiento de múltiples pasos.`,
      tavilyApiKeyTip:
        'Si se configura correctamente una clave API aquí, se utilizarán búsquedas web basadas en Tavily para complementar la recuperación de la base de conocimiento.',
      tavilyApiKeyMessage: 'Por favor, introduce tu clave API de Tavily',
      tavilyApiKeyHelp: '¿Cómo obtenerla?',
      crossLanguage: 'Búsqueda multilingüe',
      crossLanguageTip: `Selecciona uno o más idiomas para la búsqueda multilingüe. Si no se selecciona ningún idioma, el sistema busca con la consulta original.`,
      source_kb: '<b>Fuente: </b>',
      loading_source: 'Cargando fuente...',
    },
    setting: {
      profile: 'Perfil',
      profileDescription: 'Actualiza tu foto y datos personales aquí.',
      maxTokens: 'Máx. Tokens',
      maxTokensMessage: 'Se requiere el máximo de tokens',
      maxTokensTip: `Esto establece la longitud máxima de la salida del modelo, medida en el número de tokens (palabras o partes de palabras). Por defecto es 512. Si está deshabilitado, levantas el límite máximo de tokens, permitiendo que el modelo determine el número de tokens en sus respuestas.`,
      maxTokensInvalidMessage:
        'Por favor, introduce un número válido para Máx. Tokens.',
      maxTokensMinMessage:
        'El número máximo de tokens no puede ser menor que 0.',
      password: 'Contraseña',
      passwordDescription:
        'Por favor, introduce tu contraseña actual para cambiar tu contraseña.',
      model: 'Proveedores de modelos',
      modelDescription:
        'Configura los parámetros del modelo y la CLAVE API aquí.',
      team: 'Equipo',
      system: 'Sistema',
      logout: 'Cerrar sesión',
      api: 'API',
      username: 'Nombre de usuario',
      usernameMessage: '¡Por favor, introduce tu nombre de usuario!',
      photo: 'Tu foto',
      photoDescription: 'Esto se mostrará en tu perfil.',
      colorSchema: 'Esquema de color',
      colorSchemaMessage: '¡Por favor, selecciona tu esquema de color!',
      colorSchemaPlaceholder: 'Selecciona tu esquema de color',
      bright: 'Claro',
      dark: 'Oscuro',
      timezone: 'Zona horaria',
      timezoneMessage: '¡Por favor, introduce tu zona horaria!',
      timezonePlaceholder: 'Selecciona tu zona horaria',
      email: 'Dirección de correo electrónico',
      emailDescription:
        'Una vez registrado, el correo electrónico no se puede cambiar.',
      currentPassword: 'Contraseña actual',
      currentPasswordMessage: '¡Por favor, introduce tu contraseña!',
      newPassword: 'Nueva contraseña',
      newPasswordMessage: '¡Por favor, introduce tu contraseña!',
      newPasswordDescription:
        'Tu nueva contraseña debe tener más de 8 caracteres.',
      confirmPassword: 'Confirmar nueva contraseña',
      confirmPasswordMessage: '¡Por favor, confirma tu contraseña!',
      confirmPasswordNonMatchMessage:
        '¡La nueva contraseña que introdujiste no coincide!',
      cancel: 'Cancelar',
      addedModels: 'Modelos añadidos',
      modelsToBeAdded: 'Modelos a añadir',
      addTheModel: 'Añadir el modelo',
      apiKey: 'Clave API',
      apiKeyMessage:
        'Por favor, introduce la clave API (para modelos desplegados localmente, ignora esto).',
      apiKeyTip:
        'La clave API se puede obtener registrándose en el proveedor LLM correspondiente.',
      showMoreModels: 'Mostrar más modelos',
      baseUrl: 'URL base',
      baseUrlTip:
        'Si tu clave API es de OpenAI, ignóralo. Cualquier otro proveedor intermedio te dará esta URL base con la clave API.',
      modify: 'Modificar',
      systemModelSettings: 'Configurar modelos predeterminados',
      chatModel: 'Modelo de chat',
      chatModelTip:
        'El modelo de chat predeterminado para obtener palabras clave y preguntas cuando se utilizan las funciones de palabra clave automática y pregunta automática durante la fragmentación.',
      miniChatModel: 'Modelo de chat mini',
      miniChatModelTip:
        'El modelo de chat predeterminado para obtención de keywords y preguntas relacionadas.',
      embeddingModel: 'Modelo de incrustación',
      embeddingModelTip:
        'El modelo de incrustación predeterminado para cada base de conocimiento recién creada.',
      img2txtModel: 'Modelo de imagen a texto',
      img2txtModelTip:
        'El modelo img2txt predeterminado para cada base de conocimiento recién creada. Describe una imagen o video.',
      sequence2txtModel: 'Modelo de voz a texto',
      sequence2txtModelTip:
        'El modelo ASR predeterminado para cada base de conocimiento recién creada. Usa este modelo para traducir voces a texto correspondiente.',
      rerankModel: 'Modelo de reranking',
      rerankModelTip: `El modelo de reranking predeterminado para volver a clasificar fragmentos.`,
      ttsModel: 'Modelo TTS',
      ttsModelTip: 'El modelo de texto a voz predeterminado.',
      workspace: 'Espacio de trabajo',
      upgrade: 'Actualizar',
      addLlmTitle: 'Añadir LLM',
      modelName: 'Nombre del modelo',
      modelID: 'ID del modelo',
      modelUid: 'UID del modelo',
      modelNameMessage: '¡Por favor, introduce el nombre de tu modelo!',
      modelType: 'Tipo de modelo',
      modelTypeMessage: '¡Por favor, introduce el tipo de tu modelo!',
      addLlmBaseUrl: 'URL base',
      baseUrlNameMessage: '¡Por favor, introduce tu URL base!',
      vision: '¿Soporta Visión?',
      ollamaLink: 'Cómo integrar {{name}}',
      FishAudioLink: 'Cómo usar FishAudio',
      TencentCloudLink: 'Cómo usar TencentCloud ASR',
      volcModelNameMessage: '¡Por favor, introduce el nombre de tu modelo!',
      addEndpointID: 'EndpointID del modelo',
      endpointIDMessage: 'Por favor, introduce tu EndpointID del modelo',
      addArkApiKey: 'CLAVE API de VOLC ARK',
      ArkApiKeyMessage: 'Por favor, introduce tu CLAVE API de ARK',
      bedrockModelNameMessage: '¡Por favor, introduce el nombre de tu modelo!',
      addBedrockEngineAK: 'CLAVE DE ACCESO',
      bedrockAKMessage: 'Por favor, introduce tu CLAVE DE ACCESO',
      addBedrockSK: 'CLAVE SECRETA',
      bedrockSKMessage: 'Por favor, introduce tu CLAVE SECRETA',
      bedrockRegion: 'Región de AWS',
      bedrockRegionMessage: '¡Por favor, selecciona!',
      'us-east-1': 'US East (N. Virginia)',
      'us-west-2': 'US West (Oregon)',
      'ap-southeast-1': 'Asia Pacífico (Singapur)',
      'ap-northeast-1': 'Asia Pacífico (Tokio)',
      'eu-central-1': 'Europa (Fráncfort)',
      'us-gov-west-1': 'AWS GovCloud (US-Oeste)',
      'ap-southeast-2': 'Asia Pacífico (Sídney)',
      addHunyuanSID: 'ID Secreto de Hunyuan',
      HunyuanSIDMessage: 'Por favor, introduce tu ID Secreto',
      addHunyuanSK: 'Clave Secreta de Hunyuan',
      HunyuanSKMessage: 'Por favor, introduce tu Clave Secreta',
      addTencentCloudSID: 'ID Secreto de TencentCloud',
      TencentCloudSIDMessage: 'Por favor, introduce tu ID Secreto',
      addTencentCloudSK: 'Clave Secreta de TencentCloud',
      TencentCloudSKMessage: 'Por favor, introduce tu Clave Secreta',
      SparkModelNameMessage: 'Por favor, selecciona el modelo Spark',
      addSparkAPIPassword: 'Contraseña API de Spark',
      SparkAPIPasswordMessage: 'Por favor, introduce tu Contraseña API',
      addSparkAPPID: 'ID de APP de Spark',
      SparkAPPIDMessage: 'Por favor, introduce tu ID de APP',
      addSparkAPISecret: 'Secreto API de Spark',
      SparkAPISecretMessage: 'Por favor, introduce tu Secreto API',
      addSparkAPIKey: 'Clave API de Spark',
      SparkAPIKeyMessage: 'Por favor, introduce tu Clave API',
      yiyanModelNameMessage: 'Por favor, introduce el nombre del modelo',
      addyiyanAK: 'CLAVE API de Yiyan',
      yiyanAKMessage: 'Por favor, introduce tu CLAVE API',
      addyiyanSK: 'CLAVE Secreta de Yiyan',
      yiyanSKMessage: 'Por favor, introduce tu CLAVE Secreta',
      FishAudioModelNameMessage:
        'Por favor, asigna un nombre a tu modelo de síntesis de voz',
      addFishAudioAK: 'CLAVE API de Fish Audio',
      addFishAudioAKMessage: 'Por favor, introduce tu CLAVE API',
      addFishAudioRefID: 'ID de Referencia de FishAudio',
      addFishAudioRefIDMessage:
        'Por favor, introduce el ID de Referencia (déjalo en blanco para usar el modelo predeterminado).',
      GoogleModelIDMessage: '¡Por favor, introduce tu ID de modelo!',
      addGoogleProjectID: 'ID del proyecto',
      GoogleProjectIDMessage: 'Por favor, introduce tu ID del proyecto',
      addGoogleServiceAccountKey:
        'Clave de cuenta de servicio (Déjalo en blanco si usas credenciales predeterminadas de la aplicación)',
      GoogleServiceAccountKeyMessage:
        'Por favor, introduce la Clave de cuenta de servicio de Google Cloud en formato base64',
      addGoogleRegion: 'Región de Google Cloud',
      GoogleRegionMessage: 'Por favor, introduce la Región de Google Cloud',
      modelProvidersWarn: `Por favor, añade tanto el modelo de incrustación como el LLM en <b>Configuración > Proveedores de modelos</b> primero. Luego, configúralos en 'Configuración del modelo del sistema'.`,
      apiVersion: 'Versión API',
      apiVersionMessage: 'Por favor, introduce la versión API',
      add: 'Añadir',
      updateDate: 'Fecha de actualización',
      role: 'Rol',
      invite: 'Invitar',
      agree: 'Aceptar',
      refuse: 'Rechazar',
      teamMembers: 'Miembros del equipo',
      downloadStats: 'Descargar estadísticas',
      noStatsData: 'No hay datos para el período seleccionado',
      downloadStatsFailed: 'Error al descargar las estadísticas',
      fromDate: 'Fecha inicio',
      toDate: 'Fecha fin',
      groupBy: 'Agrupar por',
      groupByDay: 'Día',
      groupByMonth: 'Mes',
      subscribersOnly: 'Solo suscriptores',
      groupByAssistant: 'Agrupar por asistente',
      joinedTeams: 'Equipos unidos',
      sureDelete: '¿Estás seguro de que quieres eliminar a este miembro?',
      quit: 'Salir',
      sureQuit:
        '¿Estás seguro de que quieres salir del equipo al que te uniste?',
      secretKey: 'Clave secreta',
      publicKey: 'Clave pública',
      secretKeyMessage: 'Por favor, introduce la clave secreta',
      publicKeyMessage: 'Por favor, introduce la clave pública',
      hostMessage: 'Por favor, introduce el host',
      configuration: 'Configuración',
      langfuseDescription:
        'Rastros, evaluaciones, gestión de prompts y métricas para depurar y mejorar tu aplicación LLM.',
      viewLangfuseSDocumentation: 'Ver la documentación de Langfuse',
      view: 'Ver',
      modelsToBeAddedTooltip:
        'Si tu proveedor de modelos no aparece en la lista pero afirma ser "compatible con OpenAI", selecciona la tarjeta compatible con la API de OpenAI para añadir los modelos relevantes. ',
    },
    message: {
      registered: '¡Registrado!',
      logout: 'cerrar sesión',
      logged: '¡conectado!',
      pleaseSelectChunk: '¡Por favor, selecciona un fragmento!',
      registerDisabled: 'El registro de usuarios está deshabilitado',
      modified: 'Modificado',
      created: 'Creado',
      deleted: 'Eliminado',
      renamed: 'Renombrado',
      operated: 'Operado',
      updated: 'Actualizado',
      uploaded: 'Subido',
      200: 'El servidor devuelve los datos solicitados correctamente.',
      201: 'Datos creados o modificados correctamente.',
      202: 'Una solicitud ha sido puesta en cola en segundo plano (tarea asíncrona).',
      204: 'Datos eliminados correctamente.',
      400: 'Hubo un error en la solicitud emitida, y el servidor no creó ni modificó datos.',
      401: 'Por favor, inicia sesión de nuevo.',
      403: 'El usuario está autorizado, pero el acceso está prohibido.',
      404: 'La solicitud se realizó para un registro que no existe, y el servidor no realizó la operación.',
      406: 'El formato solicitado no está disponible.',
      410: 'El recurso solicitado ha sido eliminado permanentemente y no estará disponible de nuevo.',
      413: 'El tamaño total de los archivos subidos de una vez es demasiado grande.',
      422: 'Al crear un objeto, se produjo un error de validación.',
      500: 'Se produjo un error del servidor, por favor, comprueba el servidor.',
      502: 'Error de puerta de enlace.',
      503: 'El servicio no está disponible y el servidor está temporalmente sobrecargado o en mantenimiento.',
      504: 'Tiempo de espera de puerta de enlace.',
      requestError: 'Error de solicitud',
      networkAnomalyDescription:
        'Existe una anomalía en tu red y no puedes conectarte al servidor.',
      networkAnomaly: 'anomalía de red',
      hint: 'Pista',
    },
    fileManager: {
      name: 'Nombre',
      uploadDate: 'Fecha de subida',
      knowledgeBase: 'Base de conocimiento',
      size: 'Tamaño',
      action: 'Acción',
      addToKnowledge: 'Vincular a la base de conocimiento',
      pleaseSelect: 'Por favor, selecciona',
      newFolder: 'Nueva carpeta',
      file: 'Archivo',
      uploadFile: 'Subir archivo',
      parseOnCreation: 'Procesar al crear',
      directory: 'Directorio',
      uploadTitle: 'Arrastra y suelta tu archivo aquí para subir',
      uploadDescription:
        'Soporta carga de archivos individual o por lotes. El límite de tamaño total de carga no debe superar los 128MB.',
      local: 'Subidas locales',
      s3: 'Subidas S3',
      preview: 'Vista previa',
      fileError: 'Error de archivo',
      uploadLimit: 'No se puede exceder los 128MB de carga.',
      duplicateFile: 'El archivo "{{fileName}}" ya está en la lista',
      destinationFolder: 'Carpeta de destino',
    },
    flow: {
      cite: 'Citar',
      citeTip: 'Consejo de cita',
      name: 'Nombre',
      nameMessage: 'Por favor, introduce el nombre',
      description: 'Descripción',
      examples: 'Ejemplos',
      to: 'Para',
      msg: 'Mensajes',
      messagePlaceholder: 'mensaje',
      messageMsg: 'Por favor, introduce un mensaje o elimina este campo.',
      addField: 'Añadir opción',
      addMessage: 'Añadir mensaje',
      loop: 'Bucle',
      loopTip:
        'El bucle es el límite superior del número de bucles del componente actual, cuando el número de bucles excede el valor del bucle, significa que el componente no puede completar la tarea actual, por favor, optimiza el agente de nuevo',
      yes: 'Sí',
      no: 'No',
      key: 'Clave',
      componentId: 'ID de componente',
      add: 'Añadir',
      operation: 'operación',
      run: 'Ejecutar',
      save: 'Guardar',
      title: 'ID:',
      beginDescription: 'Aquí es donde comienza el flujo.',
      answerDescription: `Un componente que sirve como interfaz entre el humano y el bot, recibiendo las entradas del usuario y mostrando las respuestas del agente.`,
      retrievalDescription: `Un componente que recupera información de bases de conocimiento (conjuntos de datos) específicos. Asegúrate de que las bases de conocimiento que selecciones utilicen el mismo modelo de incrustación.`,
      generateDescription: `Un componente que le indica al LLM que genere respuestas. Asegúrate de que el prompt esté configurado correctamente.`,
      categorizeDescription: `Un componente que utiliza el LLM para clasificar las entradas del usuario en categorías predefinidas. Asegúrate de especificar el nombre, la descripción y los ejemplos para cada categoría, junto con el siguiente componente correspondiente.`,
      relevantDescription: `Un componente que utiliza el LLM para evaluar si la salida anterior es relevante para la última consulta del usuario. Asegúrate de especificar el siguiente componente para cada resultado del juicio.`,
      rewriteQuestionDescription: `Un componente que reescribe una consulta de usuario del componente Interact, basándose en el contexto de diálogos anteriores.`,
      messageDescription:
        "Un componente que envía un mensaje estático. Si se proporcionan varios mensajes, selecciona uno al azar para enviar. Asegúrate de que su downstream sea 'Interact', el componente de interfaz.",
      keywordDescription: `Un componente que recupera los resultados de búsqueda de los N principales de la entrada del usuario. Asegúrate de que el valor de TopN esté configurado correctamente antes de usarlo.`,
      switchDescription: `Un componente que evalúa condiciones basadas en la salida de componentes anteriores y dirige el flujo de ejecución en consecuencia. Permite una lógica de ramificación compleja al definir casos y especificar acciones para cada caso o acción predeterminada si no se cumplen las condiciones.`,
      wikipediaDescription: `Un componente que busca en wikipedia.org, usando TopN para especificar el número de resultados de búsqueda. Complementa las bases de conocimiento existentes.`,
      promptText: `Analiza los siguientes párrafos y crea un resumen detallado de hasta {max_tokens} tokens que capture la idea principal, los puntos clave de apoyo y las cifras importantes. El resumen debe estar escrito en un tono neutral y ser coherente, sirviendo como una referencia precisa del contenido original. La salida debe ser exclusivamente el texto del resumen, sin ninguna introducción, encabezado o frase de cierre.
Párrafos a continuación:
{cluster_content}`,
      createGraph: 'Crear agente',
      createFromTemplates: 'Crear a partir de plantillas',
      retrieval: 'Recuperación',
      generate: 'Generar',
      answer: 'Interactuar',
      categorize: 'Categorizar',
      relevant: 'Relevante',
      rewriteQuestion: 'Reescribir',
      rewrite: 'Reescribir',
      begin: 'Inicio',
      message: 'Mensaje',
      blank: 'Vacío',
      createFromNothing: 'Crea tu agente desde cero',
      addItem: 'Añadir elemento',
      addSubItem: 'Añadir subelemento',
      nameRequiredMsg: 'El nombre es requerido',
      nameRepeatedMsg: 'El nombre no puede repetirse',
      keywordExtract: 'Palabra clave',
      keywordExtractDescription: `Un componente que extrae palabras clave de una consulta de usuario, con Top N especificando el número de palabras clave a extraer.`,
      baidu: 'Baidu',
      baiduDescription: `Un componente que busca en baidu.com, usando TopN para especificar el número de resultados de búsqueda. Complementa las bases de conocimiento existentes.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'Un componente que busca en duckduckgo.com, permitiéndote especificar el número de resultados de búsqueda usando TopN. Complementa las bases de conocimiento existentes.',
      channel: 'Canal',
      channelTip: `Realiza búsquedas de texto o noticias en la entrada del componente`,
      text: 'Texto',
      news: 'Noticias',
      messageHistoryWindowSize:
        'Tamaño de la ventana del historial de mensajes',
      messageHistoryWindowSizeTip:
        'El tamaño de la ventana del historial de conversaciones visible para el LLM. Cuanto mayor sea, mejor, pero ten en cuenta el límite máximo de tokens del LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'Un componente que busca en https://pubmed.ncbi.nlm.nih.gov/, permitiéndote especificar el número de resultados de búsqueda usando TopN. Complementa las bases de conocimiento existentes.',
      email: 'Correo electrónico',
      emailTip:
        'El correo electrónico es un campo obligatorio. Debes introducir una dirección de correo electrónico aquí.',
      arXiv: 'ArXiv',
      arXivDescription:
        'Un componente que busca en https://arxiv.org/, permitiéndote especificar el número de resultados de búsqueda usando TopN. Complementa las bases de conocimiento existentes.',
      sortBy: 'Ordenar por',
      submittedDate: 'Fecha de envío',
      lastUpdatedDate: 'Fecha de última actualización',
      relevance: 'Relevancia',
      google: 'Google',
      googleDescription:
        'Un componente que busca en https://www.google.com/, permitiéndote especificar el número de resultados de búsqueda usando TopN. Complementa las bases de conocimiento existentes. Ten en cuenta que esto requiere una clave API de serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'Un componente que busca en https://www.bing.com/, permitiéndote especificar el número de resultados de búsqueda usando TopN. Complementa las bases de conocimiento existentes. Ten en cuenta que esto requiere una clave API de microsoft.com.',
      apiKey: 'CLAVE API',
      country: 'País y Región',
      language: 'Idioma',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'Un componente que busca en https://scholar.google.com/. Puedes usar Top N para especificar el número de resultados de búsqueda.',
      yearLow: 'Año bajo',
      yearHigh: 'Año alto',
      patents: 'Patentes',
      data: 'Datos',
      deepL: 'DeepL',
      deepLDescription:
        'Un componente que obtiene traducciones más especializadas de https://www.deepl.com/.',
      authKey: 'Clave de autenticación',
      sourceLang: 'Idioma de origen',
      targetLang: 'Idioma de destino',
      gitHub: 'GitHub',
      gitHubDescription:
        'Un componente que busca repositorios en https://github.com/. Puedes usar Top N para especificar el número de resultados de búsqueda.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'Un componente que obtiene traducciones especializadas de https://fanyi.baidu.com/.',
      appid: 'ID de aplicación',
      secretKey: 'Clave secreta',
      domain: 'Dominio',
      transType: 'Tipo de traducción',
      baiduSecretKeyOptions: {
        translate: 'Traducción general',
        fieldtranslate: 'Traducción de campo',
      },
      baiduDomainOptions: {
        it: 'Tecnología de la información',
        finance: 'Finanzas y economía',
        machinery: 'Fabricación de maquinaria',
        senimed: 'Biomedicina',
        novel: 'Literatura en línea',
        academic: 'Artículo académico',
        aerospace: 'Aeroespacial',
        wiki: 'Humanidades y ciencias sociales',
        news: 'Noticias e información',
        law: 'Leyes y reglamentos',
        contract: 'Contrato',
      },
      baiduSourceLangOptions: {
        auto: 'Detección automática',
        zh: 'Chino',
        en: 'Inglés',
        yue: 'Cantonés',
        wyw: 'Chino clásico',
        jp: 'Japonés',
        kor: 'Coreano',
        fra: 'Francés',
        spa: 'Español',
        th: 'Tailandés',
        ara: 'Árabe',
        ru: 'Ruso',
        pt: 'Portugués',
        de: 'Alemán',
        it: 'Italiano',
        el: 'Griego',
        nl: 'Holandés',
        pl: 'Polaco',
        bul: 'Búlgaro',
        est: 'Estonio',
        dan: 'Danés',
        fin: 'Finlandés',
        cs: 'Checo',
        rom: 'Rumano',
        slo: 'Esloveno',
        swe: 'Sueco',
        hu: 'Húngaro',
        cht: 'Chino tradicional',
        vie: 'Vietnamita',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'Un componente que recupera información meteorológica, como la temperatura y la calidad del aire, de https://www.qweather.com/.',
      lang: 'Idioma',
      type: 'Tipo',
      webApiKey: 'Clave API web',
      userType: 'Tipo de usuario',
      timePeriod: 'Período de tiempo',
      qWeatherLangOptions: {
        zh: 'Chino simplificado',
        'zh-hant': 'Chino tradicional',
        en: 'Inglés',
        de: 'Alemán',
        es: 'Español',
        fr: 'Francés',
        it: 'Italiano',
        ja: 'Japonés',
        ko: 'Coreano',
        ru: 'Ruso',
        hi: 'Hindi',
        th: 'Tailandés',
        ar: 'Árabe',
        pt: 'Portugués',
        bn: 'Bengalí',
        ms: 'Malayo',
        nl: 'Holandés',
        el: 'Griego',
        la: 'Latín',
        sv: 'Sueco',
        id: 'Indonesio',
        pl: 'Polaco',
        tr: 'Turco',
        cs: 'Checo',
        et: 'Estonio',
        vi: 'Vietnamita',
        fil: 'Filipino',
        fi: 'Finlandés',
        he: 'Hebreo',
        is: 'Islandés',
        nb: 'Noruego',
      },
      qWeatherTypeOptions: {
        weather: 'Pronóstico del tiempo',
        indices: 'Índice de vida meteorológica',
        airquality: 'Calidad del aire',
      },
      qWeatherUserTypeOptions: {
        free: 'Suscriptor gratuito',
        paid: 'Suscriptor de pago',
      },
      qWeatherTimePeriodOptions: {
        now: 'Ahora',
        '3d': '3 días',
        '7d': '7 días',
        '10d': '10 días',
        '15d': '12 días',
        '30d': '30 días',
      },
      publish: 'API',
      exeSQL: 'Ejecutar SQL',
      exeSQLDescription:
        'Un componente que realiza consultas SQL en una base de datos relacional, compatible con MySQL, PostgreSQL o MariaDB.',
      dbType: 'Tipo de base de datos',
      database: 'Base de datos',
      username: 'Nombre de usuario',
      host: 'Host',
      port: 'Puerto',
      password: 'Contraseña',
      switch: 'Cambiar',
      logicalOperator: 'Operador lógico',
      switchOperatorOptions: {
        equal: 'Igual a',
        notEqual: 'No igual a',
        gt: 'Mayor que',
        ge: 'Mayor o igual que',
        lt: 'Menor que',
        le: 'Menor o igual que',
        contains: 'Contiene',
        notContains: 'No contiene',
        startWith: 'Comienza con',
        endWith: 'Termina con',
        empty: 'Está vacío',
        notEmpty: 'No está vacío',
      },
      switchLogicOperatorOptions: {
        and: 'Y',
        or: 'O',
      },
      operator: 'Operador',
      value: 'Valor',
      useTemplate: 'Usar esta plantilla',
      wenCai: 'WenCai',
      queryType: 'Tipo de consulta',
      wenCaiDescription:
        'Un componente que obtiene información financiera, incluyendo precios de acciones y noticias de financiación, de una amplia gama de sitios web financieros.',
      wenCaiQueryTypeOptions: {
        stock: 'acción',
        zhishu: 'índice',
        fund: 'fondo',
        hkstock: 'Acciones de Hong Kong',
        usstock: 'Mercado de valores de EE. UU.',
        threeboard: 'Nuevo mercado OTC',
        conbond: 'Bono convertible',
        insurance: 'seguro',
        futures: 'futuros',
        lccp: 'Financiación',
        foreign_exchange: 'Divisa extranjera',
      },
      akShare: 'AkShare',
      akShareDescription:
        'Un componente que obtiene noticias sobre acciones de https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'Un componente que consulta información sobre una empresa que cotiza en bolsa utilizando su símbolo bursátil.',
      crawler: 'Rastreador web',
      crawlerDescription:
        'Un componente que rastrea el código fuente HTML de una URL especificada.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Contenido',
      },
      extractType: 'Tipo de extracción',
      info: 'Información',
      history: 'Historial',
      financials: 'Finanzas',
      balanceSheet: 'Balance',
      cashFlowStatement: 'Estado de flujo de efectivo',
      jin10: 'Jin10',
      jin10Description:
        'Un componente que recupera información financiera de la plataforma abierta Jin10, incluyendo actualizaciones de noticias, calendarios, cotizaciones y referencias.',
      flashType: 'Tipo de flash',
      filter: 'Filtro',
      contain: 'Contiene',
      calendarType: 'Tipo de calendario',
      calendarDatashape: 'Forma de datos del calendario',
      symbolsDatatype: 'Tipo de datos de símbolos',
      symbolsType: 'Tipo de símbolos',
      jin10TypeOptions: {
        flash: 'Noticias rápidas',
        calendar: 'Calendario',
        symbols: 'cotizaciones',
        news: 'referencia',
      },
      jin10FlashTypeOptions: {
        '1': 'Noticias del mercado',
        '2': 'Noticias de futuros',
        '3': 'Noticias de EE. UU. y Hong Kong',
        '4': 'Noticias de acciones A',
        '5': 'Noticias de materias primas y divisas',
      },
      jin10CalendarTypeOptions: {
        cj: 'Calendario de datos macroeconómicos',
        qh: 'Calendario de futuros',
        hk: 'Calendario del mercado de valores de Hong Kong',
        us: 'Calendario del mercado de valores de EE. UU.',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Datos',
        event: 'Evento',
        holiday: 'Día festivo',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Cotizaciones de materias primas',
        FOREX: 'Cotizaciones de divisas',
        FUTURE: 'Cotizaciones del mercado internacional',
        CRYPTO: 'Cotizaciones de criptomonedas',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Lista de materias primas',
        quotes: 'Últimas cotizaciones de mercado',
      },
      concentrator: 'Concentrador',
      concentratorDescription:
        'Un componente que recibe la salida del componente anterior y la pasa como entrada a los componentes siguientes.',
      tuShare: 'TuShare',
      tuShareDescription:
        'Un componente que obtiene breves noticias financieras de los principales sitios web financieros, lo que ayuda a la investigación cuantitativa y de la industria.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'Wallstreetcn',
        '10jqka': 'Descarga directa',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Token',
      src: 'Fuente',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de finalización',
      keyword: 'Palabra clave',
      note: 'Nota',
      noteDescription: 'Nota',
      notePlaceholder: 'Por favor, introduce una nota',
      invoke: 'Invocar',
      invokeDescription: `Un componente capaz de llamar a servicios remotos, utilizando las salidas de otros componentes o constantes como entradas.`,
      url: 'Url',
      method: 'Método',
      timeout: 'Tiempo de espera',
      headers: 'Encabezados',
      cleanHtml: 'Limpiar HTML',
      cleanHtmlTip:
        'Si la respuesta está en formato HTML y solo se desea el contenido principal, activa esta opción.',
      reference: 'Referencia',
      input: 'Entrada',
      output: 'Salida',
      parameter: 'Parámetro',
      howUseId: '¿Cómo usar el ID de agente?',
      content: 'Contenido',
      operationResults: 'Resultados de la operación',
      autosaved: 'Autoguardado',
      optional: 'Opcional',
      pasteFileLink: 'Pegar enlace del archivo',
      testRun: 'Ejecución de prueba',
      template: 'Plantilla',
      templateDescription:
        'Un componente que formatea la salida de otros componentes.1. Soporta plantillas Jinja2, primero convertirá la entrada a un objeto y luego renderizará la plantilla, 2. Simultáneamente conserva el método original de usar {parámetro} de reemplazo de cadena',
      emailComponent: 'Correo electrónico',
      emailDescription:
        'Enviar un correo electrónico a una dirección especificada.',
      smtpServer: 'Servidor SMTP',
      smtpPort: 'Puerto SMTP',
      senderEmail: 'Correo electrónico del remitente',
      authCode: 'Código de autorización',
      senderName: 'Nombre del remitente',
      toEmail: 'Correo electrónico del destinatario',
      ccEmail: 'Correo electrónico CC',
      emailSubject: 'Asunto del correo electrónico',
      emailContent: 'Contenido',
      smtpServerRequired: 'Por favor, introduce la dirección del servidor SMTP',
      senderEmailRequired:
        'Por favor, introduce el correo electrónico del remitente',
      authCodeRequired: 'Por favor, introduce el código de autorización',
      toEmailRequired:
        'Por favor, introduce el correo electrónico del destinatario',
      emailContentRequired:
        'Por favor, introduce el contenido del correo electrónico',
      emailSentSuccess: 'Correo electrónico enviado correctamente',
      emailSentFailed: 'Error al enviar el correo electrónico',
      dynamicParameters: 'Parámetros dinámicos',
      jsonFormatTip:
        'El componente upstream debe proporcionar una cadena JSON en el siguiente formato:',
      toEmailTip: 'to_email: Correo electrónico del destinatario (obligatorio)',
      ccEmailTip: 'cc_email: Correo electrónico CC (opcional)',
      subjectTip: 'subject: Asunto del correo electrónico (opcional)',
      contentTip: 'content: Contenido del correo electrónico (opcional)',
      jsonUploadTypeErrorMessage: 'Por favor, sube un archivo JSON',
      jsonUploadContentErrorMessage: 'Error en el archivo JSON',
      iteration: 'Iteración',
      iterationDescription: `Este componente primero divide la entrada en un array por "delimitador".
Realiza los mismos pasos de operación en los elementos del array en secuencia hasta que se emiten todos los resultados, lo que puede entenderse como un procesador de lotes de tareas.

Por ejemplo, dentro del nodo de iteración de traducción de texto largo, si todo el contenido se introduce en el nodo LLM, se puede alcanzar el límite de conversación única. El nodo upstream puede dividir primero el texto largo en múltiples fragmentos y cooperar con el nodo iterativo para realizar la traducción por lotes de cada fragmento para evitar alcanzar el límite de mensajes LLM para una sola conversación.`,
      delimiterTip: `
Este delimitador se utiliza para dividir el texto de entrada en varios fragmentos de texto, cada uno de los cuales se realizará como elemento de entrada de cada iteración.`,
      delimiterOptions: {
        comma: 'Coma',
        lineBreak: 'Salto de línea',
        tab: 'Tabulador',
        underline: 'Subrayado',
        diagonal: 'Barra diagonal',
        minus: 'Guion',
        semicolon: 'Punto y coma',
      },
      addVariable: 'Añadir variable',
      variableSettings: 'Configuración de variables',
      globalVariables: 'Variables globales',
      systemPrompt: 'Prompt del sistema',
      addCategory: 'Añadir categoría',
      categoryName: 'Nombre de la categoría',
      nextStep: 'Siguiente paso',
      variableExtractDescription:
        'Extrae la información del usuario en una variable global a lo largo de la conversación',
      variableExtract: 'Variables',
      variables: 'Variables',
      variablesTip: `Establece la variable de clave JSON clara con un valor vacío. Ej.
      {
        "CodigoUsuario":"",
        "NumeroTelefono":""
      }`,
      datatype: 'Tipo MIME de la solicitud HTTP',
      insertVariableTip: `Introducir / Insertar variables`,
      historyversion: 'Historial de versiones',
      filename: 'Nombre del archivo',
      version: {
        created: 'Creado',
        details: 'Detalles de la versión',
        dsl: 'DSL',
        download: 'Descargar',
        version: 'Versión',
        select: 'Ninguna versión seleccionada',
      },
      setting: 'Configuración',
      settings: {
        agentSetting: 'Configuración del agente',
        title: 'título',
        description: 'descripción',
        upload: 'Subir',
        photo: 'Foto',
        permissions: 'Permisos',
        permissionsTip:
          'Puedes establecer los permisos de los miembros del equipo aquí.',
        me: 'yo',
        team: 'Equipo',
      },
      noMoreData: 'No hay más datos',
      searchAgentPlaceholder: 'Buscar agente',
      footer: {
        profile: 'Todos los derechos reservados @ React',
      },
      layout: {
        file: 'archivo',
        knowledge: 'conocimiento',
        chat: 'chat',
      },
      prompt: 'Prompt',
      promptTip:
        'Usa el prompt del sistema para describir la tarea para el LLM, especificar cómo debe responder y delinear otros requisitos diversos. El prompt del sistema a menudo se usa junto con claves (variables), que sirven como varias entradas de datos para el LLM. Usa una barra diagonal `/` o el botón (x) para mostrar las claves a usar.',
      promptMessage: 'El prompt es requerido',
      infor: 'Ejecución de información',
      knowledgeBasesTip:
        'Selecciona las bases de conocimiento para asociarlas con este asistente de chat, o elige las variables que contienen los ID de las bases de conocimiento a continuación.',
      knowledgeBaseVars: 'Variables de la base de conocimiento',
      code: 'Código',
      codeDescription:
        'Permite a los desarrolladores escribir lógica Python personalizada.',
      inputVariables: 'Variables de entrada',
      runningHintText: 'se está ejecutando...',
      openingSwitch: 'Interruptor de apertura',
      openingCopy: 'Copiar apertura',
      openingSwitchTip:
        'Tus usuarios verán este mensaje de bienvenida al comienzo.',
      modeTip: 'El modo define cómo se inicia el flujo de trabajo.',
      beginInputTip:
        'Al definir parámetros de entrada, este contenido puede ser accedido por otros componentes en procesos posteriores.',
    },
    llmTools: {
      bad_calculator: {
        name: 'Calculadora',
        description:
          'Una herramienta para calcular la suma de dos números (dará una respuesta incorrecta)',
        params: {
          a: 'El primer número',
          b: 'El segundo número',
        },
      },
    },
  },
};
